// @flow

import { lazy } from 'react';

const RETRY_SESSION_KEY = '__affectli_chunk_reload';

function lazyWithRetry(importFn) {
    return lazy(() =>
        importFn().catch((error) => {
            const isChunkError =
                error && (
                    error.name === 'ChunkLoadError' ||
                    /loading.*chunk.*failed/i.test(error.message) ||
                    /failed to fetch dynamically imported module/i.test(error.message)
                );

            if (!isChunkError) {
                throw error;
            }

            if (!sessionStorage.getItem(RETRY_SESSION_KEY)) {
                sessionStorage.setItem(RETRY_SESSION_KEY, '1');
                if ('caches' in window) {
                    caches.keys().then(names =>
                        Promise.all(names.map(name => caches.delete(name)))
                    ).then(() => window.location.reload());
                } else {
                    window.location.reload();
                }
                return new Promise(() => {}); // Keep Suspense loader showing during reload
            }

            sessionStorage.removeItem(RETRY_SESSION_KEY);
            throw error; // Already reloaded once — let ErrorBoundary handle it
        })
    );
}

export default lazyWithRetry;
